import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import Produto from "model/administracao/cadastro/produto/Produto";
import Pessoa from "model/administracao/cadastro/Pessoa";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import Usuario from "model/administracao/cadastro/Usuario";
import ApontamentoDefeito from "model/meta/producao/ApontamentoDefeito";

class ApontamentoDefeitoService implements BaseServiceCadastros<ApontamentoDefeito> {
    

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/apontamentoDefeito/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ApontamentoDefeito>((resolve, reject): void => {
            api
                .get(`/apontamentoDefeito/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(apontamentoDefeito: ApontamentoDefeito) {
        return new Promise<ApontamentoDefeito>((resolve, reject): void => {
            api
                .post(`/apontamentoDefeito/incluir`, JSON.stringify(apontamentoDefeito))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(apontamentoDefeito: ApontamentoDefeito) {
        return new Promise<ApontamentoDefeito>((resolve, reject): void => {
            api
                .put(`/apontamentoDefeito/editar`, JSON.stringify(apontamentoDefeito))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/apontamentoDefeito/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/apontamentoDefeito/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/apontamentoDefeito/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    operacoes() {
        return new Promise<OperacaoProducao[]>((resolve, reject): void => {
            api
                .get(`/apontamentoDefeito/operacoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/apontamentoDefeito/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorio(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/apontamentoDefeito/report/apontamentoMeta`;
            url += getFilters(filters);
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    getRelatorioAgrupado(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/apontamentoDefeito/report/agrupado`;
            url += getFilters(filters);
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default ApontamentoDefeitoService;